// extracted by mini-css-extract-plugin
export default {"header":"Exercise_header__nSAcd","count":"Exercise_count__NHnBk"};